import React, { useContext } from "react";
import { store } from "../helper/Store";
import ExecutiveContent from "../components/ExecutiveContent.js";
import DetailContent from "../components/DetailContent.js";
import { Container, Modal, ModalOverlay, ModalContent, CircularProgress } from "@chakra-ui/react";

const Dashboard = ({ matrix1Ref, matrix2Ref, matrix3Ref, matrix4Ref, matrix5Ref, matrix6Ref, matrix7Ref, matrix8Ref, matrix9Ref }) => {
    const globalState = useContext(store);
    const { state } = globalState;

    const reportsMatrix2 = [
        {
            title: 'Total Available Leads',
            module: 'leads',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'all'
        },
        {
            title: ' -- Open',
            module: 'leads',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Open'
        },
        {
            title: ' -- Following Up ',
            module: 'leads',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Following'
        },
        {
            title: ' -- Not Qualified ',
            module: 'leads',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Not Qualified'
        },
        {
            title: 'Total Potential Students',
            module: 'Potentials',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'All'
        },
        {
            title: ' -- Following Up',
            module: 'Potentials',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Followup'
        },
        {
            title: ' -- Registration form sent (RFS)',
            module: 'Potentials',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Registration'
        },
        {
            title: ' -- Registration Payment Pending (RPP)',
            module: 'Potentials',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Registration Payment Pending'
        },
        {
            title: ' -- Registration Payment Confirmed (RPC)',
            module: 'Potentials',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Registration Paid'
        },
        {
            title: 'Total Candidates',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'All'
        },
        {
            title: ' -- Aptitude Test Pending ',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Aptitude Pending'
        },
        {
            title: ' -- Aptitude Test Scheduled ',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Aptitude Scheduled'
        },
        {
            title: ' -- Aptitude Test Passed',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Aptitude Passed'
        },
        {
            title: ' -- Aptitude Test Failed ',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Aptitude Failed'
        },
        {
            title: ' -- Enrollment Payment Form Sent',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Enrollement Payment form sent'
        },
        {
            title: ' -- Enrollment Payment Confirmation Pending ',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Enrollement Payment confirmation Pending'
        },
        {
            title: ' -- Enrollment Payment Paid',
            module: 'Candidates',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'Enrollement Payment paid'
        },
        {
            title: 'Total Students',
            module: 'Students',
            course_cc: 'Commercial Cookery [Certificate IV] - (Full time - 1.5 years)',
            course_hm: 'Hospitality Management [Advanced Diploma] - (Full time - 2 years)',
            course_pc: 'Patisserie [Certificate IV] - (Full time - 1.5 years)',
            course_em: 'Event Management [Diploma] - (Part time - 2 years)',
            course_tt: 'Travel and Tourism Management [Advanced Diploma] - (Full time - 1.5 years)',
            query: 'all'
        }
    ];

    const contentNavigation = {
        executive: <ExecutiveContent matrix5Ref={matrix5Ref} matrix6Ref={matrix6Ref} matrix7Ref={matrix7Ref} matrix8Ref={matrix8Ref} matrix9Ref={matrix9Ref} reportsMatrix={reportsMatrix2.slice(5, 9)} />,
        detail: <DetailContent matrix1Ref={matrix1Ref} matrix2Ref={matrix2Ref} matrix3Ref={matrix3Ref} matrix4Ref={matrix4Ref} reportsMatrix2={reportsMatrix2} />
    }
    
    return (
        <Container
            borderRadius={5}
            maxW='container.auto'
            bgColor='gray.100'
            color='#262626'
            position='fixed'
            top='140px'
            bottom={0}
            maxHeight='calc(100vh - 140px)'
            overflowY='scroll'
        >
            {contentNavigation[state.navigation]}
            <Modal
                isCentered
                isOpen={state.isLoading}
                onClose={() => { }}
                closeOnEsc={false}
                closeOnOverlayClick={false}
            >
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px) hue-rotate(90deg)'
                    sx={{
                        marginTop: '104px'
                    }}
                />
                <ModalContent
                    sx={{
                        alignItems: 'center',
                        backgroundColor: 'inherit',
                        boxShadow: 'none'
                    }}
                >
                    <CircularProgress isIndeterminate color='#73d6c2' size='40px' />
                </ModalContent>
            </Modal>
        </Container>
    );
};

export default Dashboard;